export default __webpack_public_path__ + "static/media/video.f38ead7a.svg";